import * as Sentry from '@sentry/vue';
import { getTimeZone } from '@/utils/time';

class SlowRequestManager {
  private static instance: SlowRequestManager;
  private slowRequestCount = 0;
  private hasReported = false;
  private readonly REPORTED_KEY: string = 'SENTRY_REPORTED_SLOW_REQUEST';
  private readonly THRESHOLD_COUNT: number = 5;
  private readonly THRESHOLD_TIME: number = 8000;

  private constructor() {
    // 在整个session中只上报一次
    if (sessionStorage?.getItem(this.REPORTED_KEY)) {
      this.hasReported = true;
    }
  }

  public static getInstance(): SlowRequestManager {
    if (!SlowRequestManager.instance) {
      SlowRequestManager.instance = new SlowRequestManager();
    }
    return SlowRequestManager.instance;
  }

  public trackRequest(requestTime: number, config: any): void {
    if (this.hasReported) return;

    if (
      import.meta.env.MODE === 'production' &&
      requestTime > this.THRESHOLD_TIME &&
      /https?:\/\/bapi/.test(config.url)
    ) {
      this.slowRequestCount++;
      if (this.slowRequestCount >= this.THRESHOLD_COUNT) {
        this.hasReported = true;
        requestAnimationFrame(() => {
          this.reportToSentry(config);
        });
      }
    }
  }

  private async reportToSentry(config: any) {
    try {
      const { logger } = Sentry;
      const timeZone = getTimeZone();

      logger.warn('Slow API from current IP', {
        timeZone: timeZone,
        logTag: 'slow_api',
        UID: sessionStorage.getItem('UID') || '',
        timestamp: new Date().toISOString()
      });
      sessionStorage?.setItem(this.REPORTED_KEY, '1');
    } catch (error) {
      console.log('Error capturing Sentry event:', error);
    }
  }

  private reset(): void {
    this.slowRequestCount = 0;
    this.hasReported = false;
  }
}

export const slowRequestManager = SlowRequestManager.getInstance();
